import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "main-page-notice",
  role: "alert",
  "aria-live": "polite"
}
const _hoisted_2 = { class: "container main-page-notice__content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "main-page-notice__text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "main-page-notice__label" }, "Важно"),
  /*#__PURE__*/_createElementVNode("p", null, " С 2 апреля заканчивается бесплатный доступ к базам. Успейте оплатить тарифы по старым ценам. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_HeroSection = _resolveComponent("HeroSection")!
  const _component_CompasSection = _resolveComponent("CompasSection")!
  const _component_FeaturesSection = _resolveComponent("FeaturesSection")!
  const _component_InformationSection = _resolveComponent("InformationSection")!
  const _component_AboutSection = _resolveComponent("AboutSection")!
  const _component_PricingSection = _resolveComponent("PricingSection")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_router_link, {
          class: "main-page-notice__action",
          to: { path: '/', hash: '#pricing-section' }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Перейти к тарифам ")
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_HeroSection),
    _createVNode(_component_CompasSection),
    _createVNode(_component_FeaturesSection),
    _createVNode(_component_InformationSection),
    _createVNode(_component_AboutSection),
    _createVNode(_component_PricingSection)
  ], 64))
}